import appleLogoWhite from '~/assets/images/auth/apple_logo_white.svg';

/**
 * Apple logo icon component
 * Following official Apple branding guidelines
 * @see https://developer.apple.com/design/human-interface-guidelines/sign-in-with-apple
 */
export function AppleIcon({ className }: { className?: string }) {
  return (
    <img
      src={appleLogoWhite}
      alt=""
      className={className}
      width="18"
      height="22"
      aria-hidden="true"
    />
  );
}
